import { render, staticRenderFns } from "./PersonCoursePicker.vue?vue&type=template&id=23d3c3b4"
import script from "./PersonCoursePicker.vue?vue&type=script&lang=js"
export * from "./PersonCoursePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports